import _ from 'underscore';
import Radio from 'backbone.radio';
import Api from '@/lib/api/api';
import v5_Collection from '@/collections/v5/collection';
import Device from '@/models/v5/device';

    var apiCh = Radio.channel('api');
    function fetch_by_product(collection, product, options) {
        var id = (product && product.id) || null;
        options = _({ 
            data: {
                'filter[product.id]': id
            },
            success: function(collection, resp) {
                var devices = apiCh.request('device');
                var data = resp && resp.data;

                if (!data) return;

                data.forEach(function(raw_device){
                    var d = devices.get(raw_device.id);
                    if (!d) return;
                    // Assign the product we just filtered for to this device's
                    // product. Since a device has only one product, this 
                    // should be just fine. We do this here because presently 
                    // the devices endpoint doesn't supply the relationships 
                    // which would include 'product' and could be included 
                    // automagically via Api.parse_item. 
                    //
                    // TODO: fix leaky abstraction
                    // This is ugly because this should be handled by the device
                    // type itself. Also, it doesn't handle the case when a
                    // device is unassigned from a product. Eew.
                    d.product = product;
                });
            }
        }).extend(options);
        return collection.fetch(options);
    }
    function fetch_by_devicegroup(collection, devicegroup, options) {
        var id = (devicegroup && devicegroup.id) || null;
        options = _({ data: {
            'filter[devicegroup.id]': id
        }}).extend(options);
        return collection.fetch(options);
    }
    function search(collection, term, options) {
        var deferred = $.Deferred();
        function done(results) {
            deferred.resolve(results);
        }
        function fail() {
            deferred.reject.apply(this, arguments);
        }
        options = _({ url: Api.urls.devices_search({ term: term}) }).extend(options);
        this.fetch(options)
            .done(done)
            .fail(fail.bind(this))
        ;
        // Returning a Promise so that only this function can modify
        // the Deferred object
        return deferred.promise();
    }
    var collection = new v5_Collection();
    collection.model = Device;
    collection.url = function url() {
        return Api.urls.devices();
    };
    collection.fetch_by_product = _.partial(fetch_by_product, collection);
    collection.fetch_by_devicegroup = _.partial(fetch_by_devicegroup, collection);
    collection.search = _.partial(search, collection);
    export default collection;

